import imgOutside from '../../assets/buildings/administration/outside.png';
import imgWasteWater from '../../assets/buildings/administration/waste-water.png';
import imgHeating from '../../assets/buildings/administration/heating.png';
import imgHeatingFr from '../../assets/buildings/administration/heatingFr.jpg';
import imgFireProtection from '../../assets/buildings/administration/fire-protection.png';
import imgWater from '../../assets/buildings/administration/water.png';
import imgWaterFr from '../../assets/buildings/administration/waterFr.jpg';
import { Building, BuildingTechSectors } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';
import { activeLanguage } from '../../activeLanguage';

const frenchHeating: BuildingTechSectors = {
    type: TechSector.HEATING,
    img: imgHeatingFr,
    products: [
        {
                position: { x: 158, y: 628 },
            type: ProductType.BOAX_S_SF,
        },
        {
                position: { x: 314, y: 653 },
            type: ProductType.ETANORM,
        },
        {
                position: { x: 374, y: 583 },
            type: ProductType.BOA_CVE_IMS,
        },
        {
                position: { x: 409, y: 173 },
            type: ProductType.BOA_CONTROL_PIC,
        },
        {
                position: { x: 449, y: 603 },
            type: ProductType.BOATRONIC_MS_420,
        },
        {
                position: { x: 879, y: 563 },
            type: ProductType.CALIO_PRO_PLUS_Z,
        },
        {
                position: { x: 1284, y: 503 },
            type: ProductType.CALIO_PRO_PLUS,
        },
        {
                position: { x: 1109, y: 503 },
            type: ProductType.BOA_CONTROL_DPR,
        },
        {
                position: { x: 1174, y: 473 },
            type: ProductType.BOA_CONTROL_SBV,
        },
        {
                position: { x: 1034, y: 513 },
            type: ProductType.BOA_RVK,
        },
        {
                position: { x: 1394, y: 523 },
            type: ProductType.ETALINE_Z,
        },
    ],
};

const administrationConfig: Building = {
    techSectors: [
        {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                        position: {x: 451, y: 874},
                    type: ProductType.AMA_DRAINER_4_5
                },
                {
                        position: {x: 1152, y: 866},
                    type: ProductType.COMPACTA
                },
                {
                        position: {x: 1371, y: 818},
                    type: ProductType.AMA_DRAINER_4_5
                },
                {
                        position: {x: 1393, y: 674},
                    type: ProductType.LEVELCONTROL_BASIC_2
                },
                {
                        position: {x: 1752, y: 770},
                    type: ProductType.AMA_DRAINER_BOX_UEBERFLUR
                },
            ]
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                        position: {x: 971, y: 881},
                    type: ProductType.HYADUO_2_D_FL_COMPACT
                }
            ],
        },
        activeLanguage.locale.language === 'fr'
            ? frenchHeating
            : {
            type: TechSector.HEATING,
            img: imgHeating,
            products: [
                {
                        position: {x: 240, y: 859},
                    type: ProductType.BOAX_S_SF
                },
                {
                        position: {x: 336, y: 798},
                    type: ProductType.SERIE_2000
                },
                {
                        position: {x: 468, y: 877},
                    type: ProductType.ETANORM
                },
                {
                        position: {x: 609, y: 797},
                    type: ProductType.BOA_SYSTRONIC_EPIC
                },
                {
                        position: {x: 883, y: 782},
                    type: ProductType.SISTO_16_RGAMAXX
                },
                {
                        position: {x: 1041, y: 761},
                    type: ProductType.BOA_CONTROL_DPR
                },
                {
                        position: {x: 1102, y: 791},
                    type: ProductType.CALIO_PRO_PLUS_Z
                },
                {
                        position: {x: 1278, y: 785},
                    type: ProductType.CALIO_PRO_PLUS
                },
                {
                        position: {x: 1429, y: 715},
                    type: ProductType.BOA_CONTROL_SBV
                },
                {
                        position: {x: 1555, y: 753},
                    type: ProductType.BOA_RVK
                },
                {
                        position: {x: 1716, y: 811},
                    type: ProductType.ETALINE_Z
                },
            ]
        },
        {
            type: TechSector.WATER,
            img: activeLanguage.locale.language === 'fr' ? imgWaterFr : imgWater,
            products: [
                {
                        position: {x: 258, y: 931},
                    type: ProductType.UPA
                },
                {
                        position: {x: 805, y: 693},
                    type: ProductType.SISTO_16_RGAMAXX
                },
                {
                        position: {x: 923, y: 736},
                    type: ProductType.KSB_SAFETY_BOOST
                },
                {
                        position: {x: 1060, y: 756},
                    type: ProductType.SISTO_16_TWA
                },
                {
                        position: {x: 1211, y: 693},
                    type: ProductType.DELTA_PRIMO_SVP
                },
                {
                        position: {x: 1380, y: 719},
                    type: ProductType.BOA_COMPACT_EKB
                },
            ]
        }
    ],
    img: imgOutside
}

export default administrationConfig;
